import Api from "./Api";

const getAdminHeaders = () => {
  const token = localStorage.getItem("token"); 
  return {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${token}`,
  };
};

// Testimonial API
export const createTestimonial = (formData) => {
    return Api.post('/api/admin/create-student-testimonials', formData, {
        headers: getAdminHeaders(),
    });
  };

  export const updateTestimonial = (id, formData)=>{
    return Api.post(`/api/admin/update-student-testimonials/${id}`, formData,{
      headers:getAdminHeaders(),
    })
  }

  export const deleteTestimonial = (id) => {
    return Api.delete(`/api/admin/delete-student-testimonials/${id}`, {
      headers: getAdminHeaders(),
    });
  };
  
  export const getTestimonial = () => {
    return Api.get('/api/getAll-student-testimonials', {});
  };

// Announcement API
export const createAnnouncement = (formData) => {
  return Api.post('/api/admin/create-announcements', formData, {
    headers: getAdminHeaders(),
  });
};

export const updateAnnouncement = (id, formData) => {
  return Api.post(`/api/admin/update-announcements/${id}`, formData, {
    headers: getAdminHeaders(),
  });
};

export const deleteAnnouncement = (id) => {
  return Api.delete(`/api/admin/delete-announcements/${id}`, {
    headers: getAdminHeaders(),
  });
};

export const getAnnouncements = () => {
  return Api.get('/api/get-announcements', {});
};


// Counsellor Api

export const createCounsellor = (userData) => {
  return Api.post('/api/admin/create', userData, {
    headers: getAdminHeaders(),
  });
};

export const getAllCounsellor = ()=> {
  return Api.get('/api/admin/get-all-admin',{
    headers: getAdminHeaders(),
  })
}

export const updateCounsellor = (id, details) =>{
  return Api.post(`/api/admin/update-admin/${id}`, details, {
    headers: getAdminHeaders()
  })
}

export const deleteCounsellor = (id) =>{
  return Api.delete(`/api/admin/delete-admin/${id}`,{
    headers: getAdminHeaders()
  })
}

export const getCounsellorDetails =(id)=>{
  return Api.get(`/api/admin/get-admin/${id}`,{
    headers: getAdminHeaders()
  })
}

// Question APIs
export const createQuestion = (formData) => {
  return Api.post('/api/admin/create-questions', JSON.stringify(formData), {
    headers: {
      ...getAdminHeaders(),
      "Content-Type": "application/json",
    },
  });
};

export const updateQuestion = (id, formData) => {
  return Api.post(`/api/admin/update-questions/${id}`, JSON.stringify(formData), {
    headers: {
      ...getAdminHeaders(),
      "Content-Type": "application/json",
    }
  });
};

export const deleteQuestion = (id) => {
  return Api.delete(`/api/admin/delete-questions/${id}`, {
    headers: getAdminHeaders(),
  });
};

export const getQuestion = (id) => {
  return Api.get(`/api/admin/get-question/${id}`, {
    headers: getAdminHeaders(),
  });
};

export const getAllQuestions = () => {
  const h = getAdminHeaders()
  return Api.get('/api/admin/getAll-questions', {
    headers: getAdminHeaders(),
  });
};

export const getAllRegisterStudent = () => {
  return Api.get('/api/getAll-register-students',{
    headers: getAdminHeaders(),
  });
};

export const getAllVerifiedStudent =()=>{
  return Api.get('/api/get-verified-students',{
    headers: getAdminHeaders()
  })
}

export const getAllEnrolledStudent =()=>{
  return Api.get('/api/students/enrolled',{
    headers: getAdminHeaders()
  })
}

// Verify Student API
export const verifyStudent = (studentId) => {
  return Api.post(`/api/verify-student/${studentId}`, null, {
    headers: getAdminHeaders(),
  });
};

export const enrollStudent =(id)=>{
  return Api.patch(`/api/updateEnroll-students/${id}`,null,{
    headers: {...getAdminHeaders(),
      "Content-Type": "application/json"
    }
  })
}


// Alumni Speak APIs

export const updateAlumniSpeak = (id, details) =>{
  return Api.post(`/api/admin/update-alumni-speaks/${id}`, details, {
    headers: getAdminHeaders(),
  })
}

export const createAlumniSpeak = (details) =>{
  return Api.post(`/api/admin/create-alumni-speaks`, details, {
    headers: getAdminHeaders(),
  })
}

export const deleteAlumniSpeak = (id) =>{
  return Api.delete(`/api/admin/delete-alumni-speaks/${id}`, {
    headers: getAdminHeaders(),
  })
}

// Placed Students API

export const createPlacedStudents = (details) =>{
  return Api.post('/api/admin/create-placed-students', details, {
    headers: getAdminHeaders()
  })
}

export const updatePlacedStudents = (id,details) =>{
  return Api.post(`/api/admin/update-placed-students/${id}`, details,{
    headers: getAdminHeaders()
  })
}

export const deletePlacedStudents = (id) => {
  return Api.delete(`/api/admin/delete-placed-students/${id}`,{
    headers: getAdminHeaders()
  })
}


// Dashboard Summary API

export const getDashboardSummary = () =>{
  return Api.get('/api/admin/dashboard-summary', {
    headers: getAdminHeaders()
  })
}

// Fees Structure API

export const updateFeesStructure = (id, details) =>{
  return Api.post(`/api/admin/create-fees/${id}`, details,{
    headers: getAdminHeaders()
  })
}

// Packages API
export const updatePackages =(details)=>{
  return Api.post('/api/admin/create-package', details, {
    headers: getAdminHeaders()
  })
}

// Gallery Photo API

export const postGalleryPhotos = (details) =>{
  return Api.post('/api/admin/create-image',details, {
    headers: getAdminHeaders()
  })
}

export const deleteGalleryPhotos = (id)=>{
  return Api.delete(`/api/admin/delete-image/${id}`,{
    headers: getAdminHeaders()
  })
}


// Enquiry Remark API

export const addRemarkToEnquiry = (id,remark)=> {
  return Api.post(`/api/admin/student-enquiries/remark/${id}`,{remark:remark},{
    headers: getAdminHeaders()
  })
}
// export const getEnquiryData = async () => {
//   return await axios.get("/api/enquiries"); // Replace with the correct API endpoint
// };

export const deleteMBABatchList = (studentId) => {
  return Api.delete(`/api/admin/mba_batches/${studentId}`, {
    headers: getAdminHeaders()
  });
};
export const deleteEnquiryById = (id) => {
  return Api.delete(`/api/delete-enquiries/${id}`, {
    headers: getAdminHeaders()
  });
};
export const deleteEnquiry = (id) => {
  return Api.delete(`/api/admin/student-enquiries/${id}`, {
    headers: getAdminHeaders(),
  });
};
export const deleteRegisterEnquiry = async (id) => {
  return Api.delete(`/api/admin/delete_Register_Students/${id}`, {
    headers: getAdminHeaders()
  });
};

// export const deleteStudentById = (id) => {
//   return Api.delete(`/api/admin/delete-enquiries/${id}`, {
//     headers: getAdminHeaders()
//   });
// };



// Recognitions and Approvals

export const addRecognitionsAndApprovals = (details)=> {
  
  return Api.post(`/api/admin/create-recognition-and-approvals`,details,{
    headers: getAdminHeaders()
  })
}

export const updateRecognitionsAndApprovals = (id,details)=> {
  return Api.post(`/api/admin/update-recognition-and-approvals/${id}`,details,{
    headers: getAdminHeaders()
  })
}

export const deleteRecognitionsAndApprovals = (id)=> {
  return Api.delete(`/api/admin/delete-recognition-and-approvals/${id}`,{
    headers: getAdminHeaders()
  })
}


// Tasks API

export const getCounsellorTask = (id)=> {

  return Api.get(`/api/admin/counsellors/${id}/tasks`,{
    headers: getAdminHeaders()
  })
}

export const createTask = (details) =>{
  return Api.post(`/api/admin/tasks`, details,{
    headers: getAdminHeaders()
  })
}

export const updateTaskStatus = (task_id,status)=>{
  
  return Api.patch(`/api/admin/tasks/${task_id}/status`,status,{
    headers: {...getAdminHeaders(),
      "Content-Type": "application/json"

    }
  })
}

export const getTaskSummaryCounsellorWise = (counsellor_id)=>{
  return Api.get(`/api/admin/counsellors/${counsellor_id}/tasks/count`,{
    headers: getAdminHeaders()
  })
}


// CREATE
export const createBlog = async (data) => {
  return await Api.post("/api/blogs", data, {
    headers: getAdminHeaders()
  });
};

// UPDATE (use PUT method as per RESTful convention)
export const updateBlog = async (id, data) => {
  return await Api.post(`/api/blogs/${id}?_method=PUT`, data, {
    headers: {
      ...getAdminHeaders(),
      'Content-Type': 'application/json'
    }
  });
};


// DELETE
export const deleteBlog = async (id) => {
  return await Api.delete(`/api/blogs/${id}`, {
    headers: getAdminHeaders()
  });
};


